module.exports = __webpack_public_path__ + "83ed5804c067b6cc32896bc8a11d12a1.jpg";